import React from 'react';
import { InputNumber } from 'antd';

interface NumberFieldProps {
  placeholder?: string;
  value?: number;
  onChange?: (value: number | null) => void;
  align?: 'left' | 'center' | 'right';
  format?: 'number' | 'currency' | 'percentage' | 'decimal';
  decimalPlaces?: number;
  [key: string]: any;
}

export const NumberField: React.FC<NumberFieldProps> = ({
  placeholder,
  value,
  onChange,
  align,
  format,
  decimalPlaces = 0,
  ...props
}) => {
  // Apply alignment style with proper text-align
  const containerStyle = {
    width: '100%',
    textAlign: align || 'left',
  };

  const inputStyle = {
    width: '100%',
    textAlign: align || 'left',
  };

  // Handle different format types for formatter/parser
  let formatter: ((value: number | undefined) => string) | undefined;
  let parser: ((value: string | undefined) => number) | undefined;

  // switch (format) {
  //   case 'currency':
  //     formatter = (value: number | undefined) => value ? `₹${value.toFixed(decimalPlaces)}` : '';
  //     parser = (value: string | undefined) => value ? Number(value.replace(/₹/g, '')) : 0;
  //     break;
  //   case 'percentage':
  //     formatter = (value: number | undefined) => value ? `${value.toFixed(decimalPlaces)}%` : '';
  //     parser = (value: string | undefined) => value ? Number(value.replace(/%/g, '')) : 0;
  //     break;
  //   case 'decimal':
  //   case 'number':
  //     formatter = (value: number | undefined) => value ? value.toFixed(decimalPlaces) : '';
  //     parser = (value: string | undefined) => value ? Number(value) : 0;
  //     break;
  //   default:
  //     formatter = undefined;
  //     parser = undefined;
  // }

  return (
    <div style={containerStyle}>
      <InputNumber
        style={inputStyle}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        formatter={formatter}
        parser={parser}
        precision={format ? decimalPlaces : undefined}
        min={0}
        {...props}
      />
    </div>
  );
};
